import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:상품등록 > 카테고리 관리
 * 세부설명:
*/

export class CategoryReg extends Component {
    static displayName = CategoryReg.name;

    constructor(props) {
        super(props);
        this.state = {
            CategoryMan:[],
            CategoryMid: [],
            CategorySub: [],
            Man_Cd: "",
            Man_Nm:"",
            Mid_Cd: "",
            Mid_Nm: "",
            Sub_Cd: "",
            Sub_Nm: ""
        };

        this.handleCategoryMan_Click = this.handleCategoryMan_Click.bind(this);
        this.handleCategoryMid_Click = this.handleCategoryMid_Click.bind(this);
        this.handleCategorySub_Click = this.handleCategorySub_Click.bind(this);
        this.handleCategory_Click = this.handleCategory_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CategoryDataCall();
    } 
    //카테고리 저장소
    GoodsDataSetProp = {
        CategoryMid: [],
        CategorySub:[]
    }

    async CategoryDataCall() {
        try {
            let Data = await Big3Common.Get("api/Common/BaseCode/GetCateGory");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = JSON.parse(Data.multiDataTable);
                this.GoodsDataSetProp.CategoryMid = DataSet["categorymid"];
                this.GoodsDataSetProp.CategorySub = DataSet["categorysub"];
                ////대분류 할당
                this.setState({ CategoryMan: DataSet["categoryman"]});
            }
            else {
                console.log("등록된 카테고리가 없습니다.");
            }
        }
        catch (e) {
            console.log("CategoryDataCall: ",e)
        }
        return false;
    } 
    //대분류 클릭
    handleCategoryMan_Click(ManCd, ManNm) {
        let MidList = this.GoodsDataSetProp.CategoryMid.filter(list => list.man_cd === ManCd);
        //중분류 할당
        this.setState({ CategoryMid: MidList, CategorySub:[], Man_Cd: ManCd, Man_Nm: ManNm, Mid_Cd: "", Mid_Nm: "", Sub_Cd: "", Sub_Nm: ""});
        return false;
    }
    //중분류 클릭
    handleCategoryMid_Click(ManCd,MidCd, MidNm) {
        let SubList = this.GoodsDataSetProp.CategorySub.filter(list => list.man_cd === ManCd && list.mid_cd === MidCd);
        //소분류 할당
        this.setState({ CategorySub: SubList, Mid_Cd: MidCd, Mid_Nm: MidNm, Sub_Cd: "", Sub_Nm: "" });
        return false;
    }
    //소분류 클릭
    handleCategorySub_Click(SubCd, SubNm) {
        this.setState({ Sub_Cd: SubCd, Sub_Nm: SubNm });
        return false;
    }
    //최종 확인하고 메인 이동
    handleCategory_Click(event) {

        if (this.state.Man_Cd === "" || this.state.Mid_Cd === "" || this.state.Sub_Cd === "") {

            Big3Common.ModalAlert(bootstrap, 'CategoryAlert');
            return false;
        }
        let ContentState = this.props.ContentState;
        ContentState.CategoryModel.Man_Cd = this.state.Man_Cd;
        ContentState.CategoryModel.Man_Nm = this.state.Man_Nm;
        ContentState.CategoryModel.Mid_Cd = this.state.Mid_Cd;
        ContentState.CategoryModel.Mid_Nm = this.state.Mid_Nm;
        ContentState.CategoryModel.Sub_Cd = this.state.Sub_Cd;
        ContentState.CategoryModel.Sub_Nm = this.state.Sub_Nm;
        ContentState.GoodsSizModel = [];
        ContentState.DtlSizeModel = [];
        this.props.RenderComponent('GoodsReg', ContentState);        
        event.preventDefault();
    }
    CategoryManList() {
        let ListData = this.state.CategoryMan;
        let SelectManCd = this.state.Man_Cd;
        return (
            <div className="category_slectbox">
                <div className="title">대분류</div>
                <div className="category_select large_Category row row-cols-2">
                    {ListData.map(list =>
                        <div key={list.man_cd}                            
                            className={list.man_cd === SelectManCd ? "category_item col select" : "category_item col"}                            
                            onClick={() => { this.handleCategoryMan_Click(list.man_cd, list.man_nm) }}>{list.man_nm}
                        </div>
                    )}
                </div>
            </div>
        );
    }
    CategoryMidList() {
        let ListData = this.state.CategoryMid;
        let SelectMidCd = this.state.Mid_Cd;
        return (
            <div className="category_slectbox">
                <div className="title">{ListData.length === 0 ? "" : "중분류" }</div>
                <div className="category_select middle_Category row row-cols-2">
                    {ListData.map(list =>
                        <div key={list.man_cd.concat(list.mid_cd)}                            
                            className={list.mid_cd === SelectMidCd ? "category_item col select" : "category_item col"}     
                            onClick={() => { this.handleCategoryMid_Click(list.man_cd,list.mid_cd, list.mid_nm) }}>{list.mid_nm}
                        </div>
                    )}
                </div>
            </div>
        )
    }
    CategorySubList() {
        let ListData = this.state.CategorySub;
        let SelectSubCd = this.state.Sub_Cd;
        return (
            <div className="category_slectbox">
                <div className="title">{ListData.length === 0 ? "" : "소분류"}</div>
                <div className="category_select small_Category row row-cols-2">
                    {ListData.map(list =>
                        <div key={list.man_cd.concat(list.mid_cd).concat(list.sub_cd)}
                            className={list.sub_cd === SelectSubCd ? "category_item col select" : "category_item col"}    
                            onClick={() => { this.handleCategorySub_Click(list.sub_cd, list.sub_nm) }}>{list.sub_nm}
                        </div>
                    )}
                </div>
            </div>
        )
    }
    render() {
        
        let Depth1 = this.CategoryManList();
        let Depth2 = this.CategoryMidList();
        let Depth3 = this.CategorySubList();
        return (
            <div>
                <div className="Material_wrap">
                    {Depth1}   
                    {Depth2}  
                    {Depth3}  
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleCategory_Click }>확인</button>
                </div>
                <Alert
                    id="CategoryAlert"
                    title="카테고리를 선택하여 주세요."
                />
            </div>
        );
    }
}
